import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {ContactoComponent} from '@appNeo/pages/fragmentos/contacto/contacto.component';
import {MainHeaderComponent} from '@appNeo/pages/fragmentos/main-header/main-header.component';

import {MenuDropdownNavComponent} from '@appNeo/pages/components/menu/menu-dropdown-nav/menu-dropdown-nav.component';
import {MenuDropdownComponent} from '@appNeo/pages/components/menu/menu-dropdown/menu-dropdown.component';
import {MenuDropdownElemComponent} from '@appNeo/pages/components/menu/menu-dropdown-elem/menu-dropdown-elem.component';
import {MenuBurgerComponent} from '@appNeo/pages/components/menu/menu-burger/menu-burger.component';
import {MenuSocialComponent} from '@appNeo/pages/fragmentos/menu-social/menu-social.component';

import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import {SliderComponent} from '@appNeo/pages/plugins/slider/slider.component';
import {NgxGalleryModule} from '@node_modules/ngx-gallery-9';
import {MainCtaComponent} from '@appNeo/pages/fragmentos/mainCta/main-cta.component';
import { PagesComponent } from './pages.component';
import { MainHeaderCtaComponent } from './fragmentos/main-header-cta/main-header-cta.component';
import { MainAccionesDialogoCtaComponent } from './fragmentos/main-acciones-dialogo-cta/main-acciones-dialogo-cta.component';
import { MenuUserComponent } from './fragmentos/menu-user/menu-user.component';
import { PaginaContactoComponent } from './pages/pagina-contacto/pagina-contacto.component';
import { InicioComponent } from './pages/inicio/inicio.component';
import { PaginaDemoComponent } from './pages/pagina-demo/pagina-demo.component';
import {PaginaAvisoLegalComponent} from '@appNeo/pages/pages/aviso-legal/pagina-aviso-legal.component';
import {ContentStyledTextComponent} from '@appNeo/pages/components/contentBlocks/contentStyledText/contentStyledText.component';
import {PaginaFaqsComponent} from '@appNeo/pages/pages/pagina-faqs/pagina-faqs.component';
import {AcordeonComponent} from '@appNeo/pages/components/acordeon/acordeon.component';
// import { TranslocoRootModule } from '@appNeo/transloco-root.module';
import {MainFooterComponent} from '@appNeo/pages/fragmentos/main-footer/main-footer.component';
import { TranslocoModule, TRANSLOCO_SCOPE } from '@ngneat/transloco';

import { PublicacionBloqueComponent } from './components/publicacion/publicacion-bloque/publicacion-bloque.component';
import { PublicacionBloqueTipo3Component } from './components/publicacion/publicacion-bloque-tipo3/publicacion-bloque-tipo3.component';
import { CumpleanosComponent } from './pages/cumpleanos/cumpleanos.component';
import { ComunionesComponent } from './pages/comuniones/comuniones.component';
import { OtrosEventosComponent } from './pages/otros-eventos/otros-eventos.component';
import { PAGINAS_ROUTES } from './pages-routes-data';
import { MainHeaderService } from '@appNeo/neoCore/services/mainHeader/main-header.service';
import { PreferenciasService } from '@appNeo/neoCore/services/preferencias/preferencias.service';
import { MapaAreasComponent } from './componentsTheme/mapa-areas/mapa-areas.component';
import { HelpersService } from '@appNeo/neoCore/services/helpers/helpers.service';
import { ElementoImagenSlideComponent } from './components/elemento-imagen-slide/elemento-imagen-slide.component';
import { MainHeaderReservarComponent } from './componentsTheme/main-header-reservar/main-header-reservar.component';
import { ReservarComponent } from './pages/reservar/reservar.component';

import { BottomCtaComponent } from './componentsTheme/bottom-cta/bottom-cta.component';
import { DemoFormularioComponent } from '@appNeo/neoShared/pages/demo-formulario/demo-formulario.component';
import { FormularioContactoFrontComponent } from './fragmentos/contacto/components/formulario-contacto-front/formulario-contacto-front.component';
import { ContactoFaqComponent } from './components/contactoFaq/contacto-faq/contacto-faq.component';

import { PaquetesService } from '@appNeo/core/services/paquetes/paquetes.service';
import { BloqueCumpleanosComponent } from './pages/cumpleanos/components/bloque-cumpleanos/bloque-cumpleanos.component';
import { ZonaFanComponent } from './pages/zona-fan/zona-fan.component';
import { TiposEventoService } from '@appNeo/core/services/tipos/tiposEvento/tipos-evento.service';
import { ExtrasService } from '@appNeo/core/services/extras/extras.service';
import { MapaComponent } from './components/mapa/mapa.component';
import { FormularioContactoEventoComponent } from './pages/reservar/components/formulario-contacto-evento/formulario-contacto-evento.component';
import { FormularioWizardCumpleanosComponent } from './pages/reservar/components/formulario-wizard-cumpleanos/formulario-wizard-cumpleanos.component';
import { ReservaService } from '@appNeo/core/services/reserva/reserva.service';
import { NgxStripeModule } from 'ngx-stripe';
import { InicioFrontService } from '@appNeo/core/services/inicioFront/inicio-front.service';
import { ZonaFanFrontService } from '@appNeo/core/services/precargas/zona-fan-front.service';
import { OtrosEventosFrontService } from '@appNeo/core/services/precargas/otros-eventos-front.service';
import { PaginaCookiesComponent } from './pages/cookies/pagina-cookies.component';
import { NeoSharedModule } from '@appNeo/neoShared/neoShared.module';
import { ComunionesFrontService } from '@appNeo/core/services/precargas/comuniones-front.service';
import { CumpleanosFrontService } from '@appNeo/core/services/precargas/cumpleanos-front.service';
import { FaqFrontService } from '@appNeo/core/services/precargas/faq-front.service';
import { ContactoFrontService } from '@appNeo/core/services/precargas/contacto-front.service';
import { ProximamenteDlgComponent } from './components/proximamente-dlg/proximamente-dlg.component';
import { BloqueFinanciacionComponent } from './fragmentos/bloque-financiacion/bloque-financiacion.component';



const routesPages: Routes = [
  {
    path: '',
    component: PagesComponent,
    resolve: {
      mainHeader: MainHeaderService,
      preferencias: PreferenciasService,
      HelpersService: HelpersService,
      seccionEditables: InicioFrontService
    },
    children: [
      { path: '', component: InicioComponent },
      {
        path: PAGINAS_ROUTES.PAGINA_INICIO,
        component: InicioComponent,
        data: {
          migasDePan: {
            icono: '',
            label: 'Inicio',
            link: PAGINAS_ROUTES.PAGINA_INICIO,
            tituloPagina: 'Inicio'
          },
          configuracionPagina: {
            paddingTop: false,
            paddingBottom: false
          }
        },
      },
      {
        path: PAGINAS_ROUTES.PAGINA_ZONAFAN,
        component: ZonaFanComponent,
        data: {
          migasDePan: {
            icono: '',
            label: 'Zona fan',
            link: PAGINAS_ROUTES.PAGINA_ZONAFAN,
            tituloPagina: 'Zona fan'
          },
          configuracionPagina: {
            paddingBottom: false
          }
        },
        resolve: {
          seccionesEditables: ZonaFanFrontService
        }      
      },
      {
        path: PAGINAS_ROUTES.PAGINA_CUMPLEANOS,
        component: CumpleanosComponent,
        data: {
          migasDePan: {
            icono: '',
            label: 'Cumpleaños',
            link: PAGINAS_ROUTES.PAGINA_CUMPLEANOS,
            tituloPagina: 'Cumpleaños',
          },
          configuracionPagina: {
            paddingBottom: false
          }
        },
        resolve: {
          precarga: CumpleanosFrontService
        }  
      },
      {
        path: PAGINAS_ROUTES.PAGINA_COMUNIONES,
        component: ComunionesComponent,
        data: {
          migasDePan: {
            icono: '',
            label: 'Comuniones',
            link: PAGINAS_ROUTES.PAGINA_COMUNIONES,
            tituloPagina: 'Comuniones'
          },
          configuracionPagina: {
            paddingBottom: false
          }
        },
        resolve: {
          seccionesEditables: ComunionesFrontService
        }     
      },
      {
        path: PAGINAS_ROUTES.PAGINA_OTROSEVENTOS,
        component: OtrosEventosComponent,
        data: {
          migasDePan: {
            icono: '',
            label: 'Otros eventos',
            link: PAGINAS_ROUTES.PAGINA_OTROSEVENTOS,
            tituloPagina: 'Otros eventos'
          },
          configuracionPagina: {
            paddingBottom: false
          }
        },
        resolve: {
          seccionesEditables: OtrosEventosFrontService
        } 
      },
      {
        path: PAGINAS_ROUTES.PAGINA_FAQS,
        component: PaginaFaqsComponent,
        data: {
          migasDePan: {
            icono: '',
            label: 'Faqs',
            link: PAGINAS_ROUTES.PAGINA_FAQS,
            tituloPagina: 'Preguntas frecuentes'
          },
        },
        resolve: {
          seccionesEditables: FaqFrontService
        } 
      },
      {
        path: PAGINAS_ROUTES.PAGINA_CONTACTO,
        component: PaginaContactoComponent,
        data: {
          migasDePan: {
            icono: '',
            label: 'Contacto',
            link: PAGINAS_ROUTES.PAGINA_CONTACTO,
            tituloPagina: 'Contacto'
          },
          title: 'Contacto',
          configuracionPagina: {
            paddingTop: false,
            paddingBottom: true
          }
        },
        resolve: {
          seccionesEditables: ContactoFrontService
        } 
      },
      {
        path: PAGINAS_ROUTES.PAGINA_AVISO_LEGAL,
        component: PaginaAvisoLegalComponent,
        data: {
          migasDePan: {
            icono: '',
            label: 'Aviso Legal',
            link: PAGINAS_ROUTES.PAGINA_AVISO_LEGAL,
            tituloPagina: 'Aviso Legal'
          },
        },
      },
      {
        path: PAGINAS_ROUTES.PAGINA_COOKIES,
        component: PaginaCookiesComponent,
        data: {
          migasDePan: {
            icono: '',
            label: 'Política de Cookies',
            link: PAGINAS_ROUTES.PAGINA_COOKIES,
            tituloPagina: 'Política de Cookies'
          },
        },
      },
      // {
      //   path: 'demo',
      //   component: PaginaDemoComponent,
      //   data: {
      //     migasDePan: {
      //       icono: '',
      //       label: 'Página sin definir',
      //       link: 'demo',
      //       tituloPagina: ''
      //     },
      //   },
      // },
    ]
  },
  // {
  //   path: 'reservar',
  //   component: DemoFormularioComponent,
  //   resolve: {
  //     mainHeader: MainHeaderService,
  //     preferencias: PreferenciasService,
  //     HelpersService: HelpersService
  //   }
  // },
  {
    path: PAGINAS_ROUTES.PAGINA_RESERVAR,
    component: ReservarComponent,
    resolve: {
      mainHeader: MainHeaderService,
      preferencias: PreferenciasService,
      HelpersService: HelpersService,
      tiposEvento: TiposEventoService,
      paquetes: PaquetesService,
      extras: ExtrasService,
      reserva: ReservaService
    }
  },
  {
    path: PAGINAS_ROUTES.PAGINA_RESERVAR + '/:idPaquete',
    component: ReservarComponent,
    resolve: {
      mainHeader: MainHeaderService,
      preferencias: PreferenciasService,
      HelpersService: HelpersService,
      tiposEvento: TiposEventoService,
      paquetes: PaquetesService,
      extras: ExtrasService,
      reserva: ReservaService
    }
  },
  // AREA CLIENTE
  {
    path: 'authF',
    loadChildren: () => import('./area-cliente/auth-front/auth-front.module').then(m => m.AuthFrontModule)
  },
  {
    path: 'areaCliente',
    loadChildren: () => import('./area-cliente/area-cliente/area-cliente.module').then(m => m.AreaClienteModule)
  },
  {
    path: 'encuesta',
    loadChildren: () => import('./pages/encuesta/encuesta-public.module').then(m => m.EncuestaPublicModule)
  },
];

@NgModule({
  declarations: [
      ContactoComponent,
      MainHeaderComponent,
      MenuDropdownComponent,
      MenuDropdownNavComponent,
      MenuDropdownElemComponent,
      MenuBurgerComponent,
      MenuSocialComponent,
      InicioComponent,
      SliderComponent,
      MainCtaComponent,
      PagesComponent,
      MainHeaderCtaComponent,
      MainAccionesDialogoCtaComponent,
      MenuUserComponent,
      PaginaContactoComponent,
      PaginaDemoComponent,
      PaginaAvisoLegalComponent,
      PaginaCookiesComponent,
      ContentStyledTextComponent,
      PaginaFaqsComponent,
      AcordeonComponent,
      MainFooterComponent,
      PublicacionBloqueComponent,
      PublicacionBloqueTipo3Component,
      CumpleanosComponent,
      ComunionesComponent,
      OtrosEventosComponent,
      MapaAreasComponent,
      ElementoImagenSlideComponent,
      MainHeaderReservarComponent,
      ReservarComponent,
      ZonaFanComponent,
      BottomCtaComponent,
      FormularioContactoFrontComponent,
      ContactoFaqComponent,
    BloqueCumpleanosComponent,
    MapaComponent,
    FormularioContactoEventoComponent,
    FormularioWizardCumpleanosComponent,
    ProximamenteDlgComponent,
    BloqueFinanciacionComponent],
  imports: [
    CommonModule,
    RouterModule,
    NeoSharedModule,
    NgxUsefulSwiperModule,
    NgxGalleryModule,
    // TranslocoRootModule,
    TranslocoModule,
    RouterModule.forChild(routesPages),
    NgxStripeModule
  ],
  providers: [
    { provide: TRANSLOCO_SCOPE, useValue: 'shared' }
  ],
  exports: [
    ContactoComponent,
    MainHeaderComponent,
    MenuDropdownComponent,
    MenuDropdownNavComponent,
    MenuDropdownElemComponent,
    MenuBurgerComponent,
    MenuSocialComponent,
    InicioComponent,
    SliderComponent,
    MainCtaComponent,
    PagesComponent,
    MainHeaderCtaComponent,
    MainAccionesDialogoCtaComponent,
    MenuUserComponent,
    PaginaContactoComponent,
    PaginaDemoComponent,
    PaginaAvisoLegalComponent,
    ContentStyledTextComponent,
    PaginaFaqsComponent,
    AcordeonComponent,
    MainFooterComponent,
    PublicacionBloqueComponent,
    PublicacionBloqueTipo3Component,
    CumpleanosComponent,
    ComunionesComponent,
    OtrosEventosComponent,
    MapaAreasComponent,
    ElementoImagenSlideComponent,
    MainHeaderReservarComponent,
    ReservarComponent,
    ZonaFanComponent,
    BottomCtaComponent,
    FormularioContactoFrontComponent,
    ContactoFaqComponent,
    BloqueCumpleanosComponent,
    MapaComponent,
    FormularioContactoEventoComponent,
    FormularioWizardCumpleanosComponent,
    ProximamenteDlgComponent
  ]
})
export class PagesModule {
  constructor(){}
}
